import type { Data } from '@repo/strapi'
import { useTranslations } from 'next-intl'
import { Tag } from '@/components/elementary/Tag'
import { Done } from '@/components/icons/Done'
import { Paragraph } from '@/components/typography/Paragraph'
import { cn } from '@/lib/styles'

export const PricingBenefits = ({
	pricingItem,
	className,
}: {
	pricingItem?: Data.Component<'shared.pricing-item'> | null
	className?: string
}) => {
	const t = useTranslations('pricing')
	return (
		<div className={cn('flex flex-col gap-4 py-6 px-3', className)}>
			{pricingItem?.benefitsLabel && (
				<Paragraph fontSize="bodyBoldMedium" className="text-neutral-light-900 ">
					{pricingItem?.benefitsLabel}
				</Paragraph>
			)}

			{pricingItem?.benefits?.map((benefit) => (
				<div key={benefit?.id} className="flex items-start gap-2 ">
					<Done className="size-5 text-lime-800 top-1 relative" />
					<div className="flex flex-1">
						<Paragraph fontSize="bodyRegularMedium" className="text-neutral-light-900">
							{benefit.text}
							{benefit.isNew && (
								<Tag name={t('newTag')} size="small" className="w-fit inline-block ml-1 -mb-1.5" />
							)}
						</Paragraph>
					</div>
				</div>
			))}
		</div>
	)
}

export default PricingBenefits
